import { defineMessages } from 'react-intl';

export const recentVisitHoverCardMessages = defineMessages({
  cardLabel: {
    defaultMessage: 'Quick actions for {sessionName}',
    id: 'mMlClD2/wE',
    description:
      'Accessible name for the hover card that previews a recent visit in the sidebar',
  },
  addToChat: {
    defaultMessage: 'Add to chat',
    id: '7kqzBs3Q+9',
    description:
      'Hover-card action attaching a recent visit to the Work composer as context',
  },
  viewPatient: {
    defaultMessage: 'View patient',
    id: 'JURx61Kt+t',
    description: "Hover-card action opening the recent visit's patient record",
  },
  openSession: {
    defaultMessage: 'Open session',
    id: 'nkAgmqfiNH',
    description: 'Hover-card action opening a recent visit at its session page',
  },
  actions: {
    defaultMessage: 'Visit actions',
    id: '4BT/P2TB0K',
    description: 'Accessible name for the row of actions inside the recent-visit card',
  },
});
